import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiResponseModel } from '../../core/api-response.model';
import { BaseCrudService } from '../../services/apps/generic/base.service';
import {
  ClientProjectGetDTO,
  ProjectCreateDto,
  ProjectDetailDTO,
  ProjectGetDTO,
  ProjectUpdateDto,
} from './project.model';
import { environment } from '../../../environments/environment';

export interface Project {
  id: string;
  name: string;
  description?: string;
}

@Injectable({ providedIn: 'root' })
export class ProjectService extends BaseCrudService<
  ApiResponseModel<ProjectGetDTO>,
  ProjectCreateDto,
  any,
  any
> {
  /**
   *
   */
  constructor() {
    super('/api/projects');
  }

  getProjectById(id: string) {
    return this.http.get<ProjectDetailDTO>(
      `${environment.baseApiUrl}/api/projects/${id}`
    );
  }
  updateProject(project: ProjectUpdateDto) {
    return this.http.put(`${environment.baseApiUrl}/api/projects`, project);
  }

  getClientProjects(clientId: string): Observable<ClientProjectGetDTO> {
    return this.http
      .get<ClientProjectGetDTO>(
        `${environment.baseApiUrl}/api/client-projects?clientId=${clientId}`
      )
      .pipe(map((response) => response));
  }
}
